import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';
import { ProjectState } from 'reduxStore/project/initialState';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';

import { fetchProjectSettings, updateProjectSettings } from './actions';

export const projectSettingsReducer = (builder: ActionReducerMapBuilder<ProjectState.Domain>) => {
  builder
    .addCase(fetchProjectSettings.fulfilled, (state, action) => {
      state.settingsResource = Resource.createResolvedResource({ data: action.payload });
    })
    .addCase(updateProjectSettings.fulfilled, (state, action) => {
      const project = action.payload;

      state.currentResource = Resource.createResolvedResource({ data: project });
      if (PulseTemplateModel.isPulseTemplateModel(project)) {
        state.isPulseTemplateFullyLoaded = true;
        state.settingsResource = Resource.createResolvedResource({
          data: project.project.settings,
        });
      } else {
        state.settingsResource = Resource.createResolvedResource({ data: project.settings });
      }
    });
};
